import { render } from "./LogoWTextSvg.vue?vue&type=template&id=3adbbe78"
import script from "./LogoWTextSvg.vue?vue&type=script&lang=js"
export * from "./LogoWTextSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__